
import Livestream from './Livestream'
export default class LivestreamStat {
    constructor(data = {}) {
        this.totalView_live = data.totalView_live || ""
        this.totalLike_live = data.totalLike_live || ""
        this.live = data.live ? new Livestream(data.live) : null

    }
}